"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Recipients/AddRecipientsDialogs.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _noticeBar = require('web/services/context/noticeBar');
var _campaignState = require('web/screens/Broadcast/campaignState');
var _format = require('web/screens/Broadcast/format');
var _campaignRecipientsAdd = require('shared/services/campaignRecipientsAdd');
var _addingRecipients = require('web/screens/Broadcast/addingRecipients');

var _AddPatientsDialog = require('web/screens/Broadcast/Wizard/Recipients/AddPatientsDialog'); var _AddPatientsDialog2 = _interopRequireDefault(_AddPatientsDialog);
var _UploadCsvDialog = require('web/screens/Broadcast/Wizard/Recipients/UploadCsvDialog'); var _UploadCsvDialog2 = _interopRequireDefault(_UploadCsvDialog);
var _pending = require('web/screens/Broadcast/Wizard/Recipients/pending');
var _importDraft = require('web/screens/Broadcast/Wizard/importDraft');











/* What the notice says after an Add: on a draft, what was added and who was
 * already there or got new values (Rev 32 V5); once sending has started,
 * also that they wait for the next send (Rev 30). */
 const noticeOf = (totals, hasStarted) => {
  if (hasStarted) return _importDraft.addedNotice.call(void 0, totals)
  const { NewRecipients: added, AlreadyInCampaign: already } = totals
  const updated = _nullishCoalesce(totals.UpdatedRecipients, () => ( 0))
  if (!added && updated) {
    return `Updated the values of ${_format.pluralize.call(void 0, updated, 'recipient', 'recipients')} already in the campaign.`
  }
  const there = already ? ` ${_format.pluralize.call(void 0, already, 'was', 'were')} already in the campaign` : ''
  return `Added ${_format.pluralize.call(void 0, added, 'recipient', 'recipients')}.${there}${there && updated ? `; ${_format.formatCount.call(void 0, updated)} got updated values` : ''}${there ? '.' : ''}`
}; exports.noticeOf = noticeOf

/* Rev 30 Z2 / Rev 31 v2: Add existing (the patient table in a dialog, which
 * adds and notifies on its own, D-55, D-78) and Add from CSV, on both the
 * wizard's Recipients step and the campaign page. Each confirm adds straight
 * to the campaign (AddCampaignRecipients); the table reloads on its success
 * and a notice says what was added. A refused Add keeps the dialog open with
 * the reason. P2': a file goes to the background (Background); once the
 * server has taken it the dialog closes and the notice says it keeps going,
 * while the recipients screen's progress slot shows how far it is. */
const AddRecipientsDialogs = ({ campaign, open, onClose, onSetDefault }) => {
  const { CampaignKey, TemplateFields } = campaign
  const hasStarted = _campaignState.hasCampaignStarted.call(void 0, campaign)
  const { showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )

  const add = _react.useCallback.call(void 0, 
    async (pending, count = 0) => {
      const variables = TemplateFields.map(f => f.Name)
      const request = _pending.toRequest.call(void 0, CampaignKey, pending, variables)
      // The server keeps only files for a background Add (review F-4).
      const isFiles = request.Sources.length > 0 && request.Sources.every(s => s.Kind === 'file')
      const reply = await _actions2.default.addCampaignRecipients(isFiles ? { ...request, Background: true } : request)
      showSuccessBar(_campaignRecipientsAdd.isBackgroundAddReply.call(void 0, reply) ? _addingRecipients.addStartedNotice.call(void 0, count) : exports.noticeOf.call(void 0, reply.Totals, hasStarted))
      onClose()
    },
    [CampaignKey, TemplateFields, hasStarted, showSuccessBar, onClose],
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_AddPatientsDialog2.default, {
        isOpen: open === 'existing',
        campaign: campaign,
        onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
      )
      , _react2.default.createElement(_UploadCsvDialog2.default, {
        isOpen: open === 'csv',
        campaign: campaign,
        onClose: onClose,
        onAdd: add,
        onSetDefault: onSetDefault && (variable => {
          onClose()
          onSetDefault(variable)
        }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, AddRecipientsDialogs)
